import Vue from "vue";

Vue.filter("date", (str) => str.substring(0, 10));

Vue.filter("price", function (value) {
  return value + " ₮ ";
});

Vue.filter("qty", function (value) {
  return value + " ш ";
});

Vue.filter("percent", function (value) {
  return value + " % ";
});

Vue.filter("pricewithindexof", function (value) {
  if (value > 0) {
    var converted = value.toString();
    var position = converted.indexOf(".");
    if (position > "0") {
      var returned_value = converted.substring(0, position);
      return Number(returned_value).toLocaleString() + " ₮ ";
    }
    return Number(value).toLocaleString() + " ₮ ";
  }
  return Number(value).toLocaleString() + " ₮ ";
});

Vue.filter("pricewithindex", function (value) {
  if (value > 0) {
    var converted = value.toString();
    var position = converted.indexOf(".");
    if (position > "0") {
      var returned_value = converted.substring(0, position);
      return Number(returned_value).toLocaleString();
    }
    return Number(value).toLocaleString();
  }
  return Number(value).toLocaleString();
});

Vue.filter("typeClass", function (value, isType, isPartner) {
  if (value === "StoreManagement" && isPartner === 0) {
    return "type-bg-1";
  }
  if (value === "StoreManagementAdd" && isPartner === 0) {
    return "type-bg-1";
  }
  if (value === "ByHand" && isPartner === 0) {
    return "type-bg-3";
  }
  if (value === "StoreManagementReturn" && isPartner === 0) {
    return "type-bg-4";
  }
  if (value === "MeBonus" && isPartner === 0) {
    return "type-bg-2";
  }
  if (value === "MeBonus" && isPartner === 1) {
    return "type-bg-2";
  }
  if (value === "ByHand" && isPartner === 1) {
    return "type-bg-3";
  }
  if (value === "StoreManagementReturn" && isPartner === 1) {
    return "type-bg-4";
  }
  if (value === "StoreManagement" && isPartner === 1) {
    return "type-bg-1";
  }
  if (value === "ServiceCommission" && isPartner === 0) {
    return "type-bg-5";
  } else {
    return "type-bg-default";
  }
});
